import * as shared from "./application";


export const ServiceProxy = new shared.ServiceProxy(
  process.env.REACT_APP_API_URL || "");
